import React from 'react';
import styled from 'styled-components';
import { Theme } from '../theme';

// Chart viewing modes
export type ChartMode = 'overview' | 'treasure-hunt';

const ToggleContainer = styled.div<{ theme: Theme }>`
  display: flex;
  background: ${props => props.theme.surface};
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  padding: 2px;
  gap: 2px;
`;

const ModeButton = styled.button<{ active: boolean; theme: Theme }>`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: ${props => props.active ? props.theme.primary : 'transparent'};
  color: ${props => props.active ? 'white' : props.theme.text};
  font-size: 14px;
  font-weight: ${props => props.active ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    background: ${props => props.active ? props.theme.primary : props.theme.border};
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const ModeIcon = styled.span`
  font-size: 16px;
`;

const ModeLabel = styled.span`
  font-size: 13px;
  font-weight: inherit;
`;

interface ChartModeToggleProps {
  mode: ChartMode;
  onModeChange: (mode: ChartMode) => void;
  theme: Theme;
  predictionCount?: number;
}

export const ChartModeToggle: React.FC<ChartModeToggleProps> = ({
  mode,
  onModeChange,
  theme,
  predictionCount = 0
}) => {
  return (
    <ToggleContainer theme={theme}>
      <ModeButton
        active={mode === 'overview'}
        onClick={() => onModeChange('overview')}
        theme={theme}
        title="Overview mode - see all predictions at once"
      >
        <ModeIcon>🎯</ModeIcon>
        <ModeLabel>Overview</ModeLabel>
      </ModeButton>
      
      <ModeButton
        active={mode === 'treasure-hunt'}
        onClick={() => onModeChange('treasure-hunt')}
        theme={theme}
        title={`Treasure hunt mode - explore ${predictionCount} predictions one by one`}
      >
        <ModeIcon>🗺️</ModeIcon>
        <ModeLabel>Hunt</ModeLabel>
      </ModeButton>
    </ToggleContainer>
  );
};

export default ChartModeToggle;